import React from 'react'

const LeftArrowIcon = (props = {}) => {
  const {
    className = '',
    width = '40',
    height = '40',
    fill = 'none',
    viewBox = '0 0 40 40',
    dataTestId = 'left-arrow-icon',
    ariaLabel = 'Left Icon',
    fillColor = '#5F5F5F', // Set default fill color to white
  } = props || {}
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill={fill}
      className={className}
      viewBox={viewBox}
      data-testid={dataTestId}
      aria-label={ariaLabel}>
      <rect width="40" height="40" rx="20" fill="#F5F5F5" />
      <path
        d="M15 20C15 19.4478 15.3923 19.0002 15.876 19L26.124 19C26.6079 19 27 19.4477 27 20C27 20.5523 26.6079 21 26.124 21L15.876 21C15.3923 20.9998 15 20.5522 15 20Z"
        fill={fillColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.3813 20.6187C13.0396 20.277 13.0396 19.723 13.3813 19.3813L19.5063 13.2563C19.848 12.9146 20.402 12.9146 20.7437 13.2563C21.0854 13.598 21.0854 14.152 20.7437 14.4937L15.2374 20L20.7437 25.5063C21.0854 25.848 21.0854 26.402 20.7437 26.7437C20.402 27.0854 19.848 27.0854 19.5063 26.7437L13.3813 20.6187Z"
        fill={fillColor}
      />
    </svg>
  )
}

export default LeftArrowIcon
export { LeftArrowIcon }
